export const handleEnter = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
        e.preventDefault()
        e.stopPropagation()
    }
}
